import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTheme } from "@mui/material";

const DURATION_MS = 800;

function TopProgressBar() {
  const location = useLocation();
  const theme = useTheme();
  const [runId, setRunId] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setRunId((n) => n + 1);
    setVisible(true);
    const timeoutId = setTimeout(() => setVisible(false), DURATION_MS);
    return () => clearTimeout(timeoutId);
  }, [location.pathname]);

  if (!visible) return null;

  const color = theme.palette.primary.main;

  return (
    <>
      <style>{`
        @keyframes topbar-progress {
          0%   { width: 0%;   opacity: 1; }
          70%  { width: 90%;  opacity: 1; }
          100% { width: 100%; opacity: 0; }
        }
      `}</style>
      <div
        key={runId}
        aria-hidden
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          height: 3,
          zIndex: theme.zIndex.appBar + 2,
          backgroundColor: color,
          boxShadow: `0 0 8px ${color}, 0 0 4px ${color}`,
          pointerEvents: "none",
          animation: `topbar-progress ${DURATION_MS}ms ease-out forwards`,
        }}
      />
    </>
  );
}

export default TopProgressBar;
